











































import { Component, Vue } from 'vue-property-decorator';
import Support from '@/components/BrowserSupport.vue'; // @ is an alias to /src
import Changelog from '@/components/Changelog.vue';

@Component({
  components: {
    Support, Changelog,
  },
})
export default class About extends Vue {}
